import { installExpoGlobalPolyfill } from './dangerous-internal';
installExpoGlobalPolyfill();

//# sourceMappingURL=index.web.js.map
